/*
 * @Description: 支付审核
 * @Date: 2022-12-09 10:11:37
 */
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { labour } from '@/api/ajax';
import { downloadFile, previewFile } from '../../../../methods';
import { moneyInt, moneyInt3 } from '../../../../tools/money';
let example = new TableRenderClass({ fields, search });

const dealQuery = query => {
  const empty = new Set(['', undefined, null]);
  return Object.keys(query).reduce(
    (pre, cur) => {
      if (!empty.has(query[cur])) {
        pre[cur] = query[cur];
      }
      return pre;
    },
    { taxType: 2 }
  );
};

const reviewedTableColumn = example.createPart({
  name: '待审核',
  search: [
    'payOrderNo',
    'fullName',
    'phone',
    'projectNameTax',
    'projectNo',
    'indusName',
    'taxTime',
    'payTime'
  ],
  moreBtnArr: [
    {
      name: '导出',
      type: 'primary',
      fn: async (app, table) => {
        let query = { ...table.searchQuery };
        delete query.pageNo;
        delete query.pageSize;
        await labour.labourExport(dealQuery(query));
        table.$message({
          type: 'success',
          message: '操作成功，请到下载中心查看文件下载进度'
        });
      }
    },
    {
      name: '批量下载回单',
      type: 'primary',
      fn: async (app, table) => {
        let query = { ...table.searchQuery };
        delete query.pageNo;
        delete query.pageSize;
        await labour.labourVoucherUrlExport(dealQuery(query));
        table.$message({
          type: 'success',
          message: '操作成功，请到下载中心查看文件下载进度'
        });
      }
    }
  ],
  list: params => {
    return labour.labourList(dealQuery(params));
  },
  requestNow: true,
  fields: [
    'index',
    {
      label: '项目订单编号',
      prop: 'payOrderNo',
      width: 230,
      render: (h, ctx, row) => {
        const { href } = ctx.parent.$router.resolve({
          path: '/orderMgmt/list',
          query: { orderNo: row.payOrderNo, part: 1 }
        });
        return (
          <el-button type="text" onClick={() => window.open(href, '_blank')}>
            {row.payOrderNo}
          </el-button>
        );
      }
    },
    { label: '终端服务人员', prop: 'fullName', width: 120 },
    { label: '身份证号', prop: 'cardId' },
    { label: '手机号', prop: 'phone' },
    { label: '项目名称', prop: 'projectName' },
    { label: '项目编码', prop: 'projectNo' },
    { label: '工业方', prop: 'indusName' },
    { label: '服务商', prop: 'enterpriseName' },
    { label: '服务商税款到账时间', prop: 'taxTime', width: 180 },
    { label: '终端收款时间', prop: 'payTime', width: 120 },
    { label: '支付方式', prop: 'payType' },
    { label: '支付通道', prop: 'payPassagewayName' },
    {
      label: '终端结算金额（元）',
      prop: 'taskPayPrice',
      width: 160,
      formatter: (row, ctx, v) => moneyInt((v || 0) * 100)
    },
    {
      label: '本月累计收入（元）',
      prop: 'cumMoney',
      width: 120,
      formatter: (row, ctx, v) => moneyInt((v || 0) * 100)
    },
    {
      label: '减除费用（元）',
      prop: 'monthDeductFee',
      formatter: (row, ctx, v) => moneyInt3((v || 0) * 1000)
    },
    {
      label: '累计减除费用（元）',
      prop: 'cumDeductFee',
      width: 120,
      formatter: (row, ctx, v) => moneyInt3((v || 0) * 1000)
    },
    {
      label: '应预缴所得额（元）',
      prop: 'prepaidIncomeTax',
      width: 120,
      formatter: (row, ctx, v) => moneyInt3((v || 0) * 1000)
    },
    {
      label: '适用税率',
      prop: 'taxRate',
      formatter: (row, ctx, cellValue) =>
        `${parseInt(cellValue * 10000) / 100}%`
    },
    {
      label: '速算扣除数（元）',
      prop: 'quickDeduct',
      width: 100,
      formatter: (row, ctx, v) => moneyInt((v || 0) * 100)
    },
    {
      label: '累计已预缴税额（元）',
      prop: 'cumPrepaidTaxAmount',
      width: 120,
      formatter: (row, ctx, v) => moneyInt((v || 0) * 100)
    },
    {
      label: '应预缴税额（元）',
      prop: 'prepaidTaxAmount',
      width: 100,
      formatter: (row, ctx, v) => moneyInt((v || 0) * 100)
    },
    {
      label: '税后收入（元）',
      prop: 'taxAfterAmount',
      formatter: (row, ctx, v) => moneyInt((v || 0) * 100)
    },
    {
      label: '支付回单',
      width: 140,
      render: (h, ctx, row) => {
        return (
          <div>
            <el-button
              disabled={!row.bankPayVoucherUrl}
              type="text"
              onClick={() => {
                previewFile(row.bankPayVoucherUrl);
              }}
            >
              查看
            </el-button>
            <el-button
              disabled={!row.bankPayVoucherUrl}
              type="text"
              onClick={() => {
                downloadFile(row.bankPayVoucherUrl);
              }}
            >
              下载
            </el-button>
          </div>
        );
      }
    }
  ]
});
export default {
  name: '劳务个税预扣预缴税款（一般劳务）',
  childMenu: [reviewedTableColumn]
};
